import React, { type SyntheticEvent } from 'react';
import { styled } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import ChevronRightIcon from '@atlaskit/icon/glyph/chevron-right';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import { AnalyticsEventToProps } from '@atlassian/jira-product-analytics-bridge';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import messages from './messages';

type Props = Intl & {
	showHowTo: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onClick: (arg1: SyntheticEvent<any>, arg2: UIAnalyticsEvent) => void;
};

const ChevronIconComponent = ({ onClick, showHowTo, intl }: Props) => (
	<ChevronIcon onClick={onClick}>
		{showHowTo ? (
			<ChevronDownIcon
				label={intl.formatMessage(messages.hideHowToRead)}
				size="medium"
				primaryColor={token('color.text.brand', colors.B400)}
			/>
		) : (
			<ChevronRightIcon
				label={intl.formatMessage(messages.howToRead)}
				size="medium"
				primaryColor={token('color.text.brand', colors.B400)}
			/>
		)}
	</ChevronIcon>
);

const ChevronWithAnalytics = AnalyticsEventToProps('reportPageHeader', {
	onClick: 'howToToggled',
})(ChevronIconComponent);

export default injectIntl(ChevronWithAnalytics);

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ChevronIcon = styled.div<any>({
	cursor: 'pointer',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > span': {
		verticalAlign: 'bottom',
	},
});
